module.exports = __webpack_public_path__ + "img/Kid3.4dc901aa.png";